export default __webpack_public_path__ + "static/media/file.d2806b9d.svg";